import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "gamificationv2" */ './Container'));
